import { z } from 'zod';
/**
 * Price alerts: a horizontal line on the chart that fires once when price
 * reaches it — the same thing MT5 calls an alert.
 *
 * `direction` is which side price has to reach the line FROM, not a choice the
 * trader makes separately. It is fixed when the line is placed or dropped: a
 * line above the market fires on `above` (price >= line), a line below it on
 * `below` (price <= line). That is what makes dragging a line across the
 * market do the obvious thing instead of firing on the spot.
 */
export const PRICE_ALERT_DIRECTIONS = ['above', 'below'];
export const priceAlertInputSchema = z.object({
    symbol: z.string().min(1).max(32),
    price: z.number().finite().positive(),
    direction: z.enum(PRICE_ALERT_DIRECTIONS),
    note: z.string().max(128).default(''),
});
/**
 * A partial change. Moving the price also re-arms the line: a triggered alert
 * that is dragged somewhere new is plainly meant to fire again.
 */
export const priceAlertPatchSchema = z.object({
    price: z.number().finite().positive().optional(),
    direction: z.enum(PRICE_ALERT_DIRECTIONS).optional(),
    note: z.string().max(128).optional(),
    enabled: z.boolean().optional(),
    /** Clear the trigger so the line fires again. */
    rearm: z.boolean().optional(),
});
/** Which way a line at `level` has to be reached from, given the price now. */
export function alertDirectionFor(level, price) {
    return level >= price ? 'above' : 'below';
}
/**
 * Whether price has reached the line.
 *
 * Takes a range rather than a single price so a spike that went through the
 * line and back between two polls still counts — the caller passes the live
 * bar's high and low when that bar is newer than the arming.
 */
export function alertReached(alert, high, low) {
    return alert.direction === 'above' ? high >= alert.price : low <= alert.price;
}
//# sourceMappingURL=priceAlert.js.map